// Module Vuex pour obsolescenceFlags
const state = { data: null, loading: false, error: null }
const mutations = {
  SET_DATA(state, data) { state.data = data },
  SET_LOADING(state, loading) { state.loading = loading },
  SET_ERROR(state, error) { state.error = error }
}
const actions = {
  setData({ commit }, data) { commit('SET_DATA', data) },
  setLoading({ commit }, loading) { commit('SET_LOADING', loading) },
  setError({ commit }, error) { commit('SET_ERROR', error) }
}
const getters = {
  data: state => state.data,
  loading: state => state.loading,
  error: state => state.error
}
export default { namespaced: true, state, mutations, actions, getters }
